<template>
    <section class="team__member-reveal">
        <p
            v-text="spliceContent(baseCopy)"
            class="team__member-copy team__member-copy--desktop"
        />
        <button
            v-if="!baseReveal"
            @click="toggleCopy()"
            v-text="$parent.buttonTextPrimary"
            class="team__member-cta"
        />
        <div class="team__copy-container">
            <transition-panel>
                <p
                    v-show="baseReveal"
                    v-text="joinContent(baseCopy)"
                    class="paragraph-01 team__member-copy"
                />
            </transition-panel>
            <button
                v-show="baseReveal"
                @click="toggleCopy()"
                v-text="$parent.buttonTextSecondary"
                class="team__member-cta"
            />
        </div>
    </section>
</template>

<script>
import TransitionPanel from '@/components/TransitionPanel';

export default {
    name: 'BaseReveal',
    components: {
        TransitionPanel,
    },
    props: {
        baseCopy: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            baseReveal: false,
        };
    },
    methods: {
        toggleCopy() {
            this.baseReveal = !this.baseReveal;
        },
        spliceContent(content) {
            const splicedContent = content.split('.')[0];
            return `${splicedContent}.`;
        },
        joinContent(content) {
            const joinedContent = content;
            return joinedContent
                .split('.')
                .slice(1)
                .join('.');
        },
    },
};
</script>



// WEBPACK FOOTER //
// BaseReveal.vue?b95c6a18